import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { BPProfilesAttributesService, DocumentUrlExpression, IProfileAttribute, IProfileAttributeDocument, IProfileAttributeModel, ProfileAttributeAgreeType, ProfileAttributeValueType } from './bp-profiles-attributes.service';
import { LOV_DOCTYPE, LovService } from '../../../shared/services/lov.service';
import * as _ from 'underscore';
import { ILov } from '../../../../type_definitions/datatypes';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { util } from '../../../shared/util';
import { ScrollService } from '../../../shared/scroll/scroll.service';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { Dictionary } from '../../../../type_definitions/vendor';
import { GaDeferredService } from '../../../shared/services/ga-deferred.service';
import { BPProfilesViewCode } from '../bp-profiles.service';

@Component({
  selector: 'bp-profiles-attributes',
  template: `
    <div class="profile-attribute-wrapper">
      <form #profileAttributesForm="ngForm">
        <div class="profile-attribute" *ngFor="let profileAttribute of profileAttributes; let idx = index; trackById" [id]="profileAttribute.code || profileAttribute.id" [class.editable]="editingMode">
          <bp-profiles-attributes-value [profileAttribute]="profileAttribute" [showInfo]="showInfoWhenEdit" [isEditable]="editingMode && isFieldEditable(profileAttribute)" [getDocumentUrl]="getDocumentUrl"></bp-profiles-attributes-value>

          <div class="row profile-attribute-control radio-control align-items-center" *ngIf="editingMode && isFieldEditable(profileAttribute)">
            <div class="radio col-md-3 col-3 mb-2">
              <label class="profile-attribute-selection">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" [name]="getControlName('input-radio', idx)" [(ngModel)]="profileAttribute.attributeValue.agreeing" [value]="'${ProfileAttributeAgreeType.AGREE}'">
                  <span class="form-check-label ms-2">{{ getAgreeLabel(profileAttribute) | translate }}</span>
                </div>
              </label>
            </div>

            <div class="radio col-md-5 col-6 mb-2">
              <label class="profile-attribute-selection">
                <div [ngClass]="{'row has-attribute-input': !isTypeBoolean(profileAttribute), 'form-check form-check-inline w-100': isTypeBoolean(profileAttribute)}">
                  <span [ngClass]="{ 'col-auto pe-0': !isTypeBoolean(profileAttribute) }">
                    <input class="form-check-input"  type="radio" [name]="getControlName('input-radio', idx)" [(ngModel)]="profileAttribute.attributeValue.agreeing" [value]="'${ProfileAttributeAgreeType.NOT_AGREE}'">
                  </span>
                  <span class="form-check-label ms-2" *ngIf="isTypeBoolean(profileAttribute)" translate>GA.GENERAL.NO</span>

                  <div class="col profile-attribute-input" *ngIf="!isTypeBoolean(profileAttribute)" [class.has-error]="hasValidationError(profileAttribute)">
                    <div [ngClass]="{ 'input-group input-group-sm': profileAttribute.unitType }">
                      <input type="text" [name]="getControlName('input-value', idx)" class="form-control" [(ngModel)]="profileAttribute.attributeValue.realValue" *ngIf="isTypeReal(profileAttribute)" [required]="isFieldRequired(profileAttribute)" [disabled]="isSelectDisabled(profileAttribute)">
                      <select class="form-select form-select-sm" [name]="getControlName('input-select', idx)" *ngIf="isTypeList(profileAttribute)" [(ngModel)]="profileAttribute.attributeValue.codeValue" [required]="isFieldRequired(profileAttribute)" [compareWith]="compareSelectValues('id')" [disabled]="isSelectDisabled(profileAttribute)">
                        <option></option>
                        <option *ngFor="let list of profileAttribute.listOfValues; trackById" [ngValue]="list">{{ list | format: 'formatLov' }}</option>
                      </select>
                      <span class="input-group-text">{{ profileAttribute.unitType }}</span>
                    </div>
                  </div>
                </div>
              </label>
            </div>

            <div class="radio col-md-3 offset-md-1 col-3 mb-2" *ngIf="!isTypeBoolean(profileAttribute)">
              <label class="profile-attribute-selection">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" [name]="getControlName('input-radio', idx)" [(ngModel)]="profileAttribute.attributeValue.agreeing" [value]="'${ProfileAttributeAgreeType.NOT_AVAILABLE}'">
                  <span class="form-check-label ms-2" translate>GA.GENERAL.NA</span>
                </div>
              </label>
            </div>

            <div class="col-sm-12">
              <input type="text" [name]="getControlName('input-comment', idx)" class="form-control input-comment-control" [placeholder]="'GA.GENERAL.COMMENTS' | translate" [(ngModel)]="profileAttribute.attributeValue.comment" [disabled]="isCommentFieldDisabled(profileAttribute)">
            </div>

            <div class="col-sm-12" *ngIf="showDocumentButton">
              <div class="profile-attribute-upload-row" *ngFor="let document of profileAttribute.attributeValue?.documents; let docIdx = index; trackById" [hidden]="document.isDeleted">
                <div class="profile-attribute-upload-col">
                  <select class="form-select form-select-sm" [name]="getControlName('input-doc-type', idx, docIdx)" [(ngModel)]="document.documentType" [compareWith]="compareSelectValues('code')" (change)="onDocumentChange(document)">
                    <option></option>
                    <option *ngFor="let list of profileAttribute.listOfValues; trackById" [ngValue]="list">{{ list | format: 'formatLov' }}</option>
                  </select>
                </div>
                
                <div class="profile-attribute-upload-col">
                  <input type="text" class="form-control" [name]="getControlName('input-doc-description', idx, docIdx)" [(ngModel)]="document.description" [placeholder]="'GA.GENERAL.DESCRIPTION' | translate" (change)="onDocumentChange(document)">
                </div>
                
                <div class="profile-attribute-upload-col">
                  <file-button
                    class="btn-default"
                    [url]="getUploadUrl(profileAttribute.id)"
                    [formData]="document.formData"
                    [uploading]="document.uploading"
                    [submitting]="document.submitting"
                    [disabled]="document.id"
                    (onUploadDone)="onUploadDone(document)"
                    (onUploadFailed)="onUploadDone(document)"
                    (onFileAdd)="onFileAdd($event, document)">
                    <i class="fa fa-folder-open-o"></i>
                  </file-button>
                  <button class="btn btn-default" (click)="deleteDocument(document)"><i class="fa fa-trash-o"></i></button>
                </div>
              </div>
              
              <!-- for validation purpose when document is required -->
              <input type="number" [name]="getControlName('input-doc', idx)" [(ngModel)]="profileAttribute.countDocuments" [hidden]="true" *ngIf="isDocumentRequired(profileAttribute)" required min="1">

              <span>
                <button class="btn btn-default" [translateParams]="{ label: ('GA.GENERAL.DOCUMENT' | translate)}" translate (click)="addDocument(profileAttribute)">GA.BUTTONS.ADD_LABEL</button>
                <span class="text-danger margin-left-sm" [class.has-error]="isDocumentInvalid(profileAttribute)" *ngIf="isDocumentInvalid(profileAttribute)" translate [translateParams]="{ label: 'GA.GENERAL.DOCUMENT' | translate }">GA.VALIDATION.REQUIRED</span>
              </span>
            </div>
          </div>
        </div>
      </form>
    </div>
  `,
  styleUrls: ['./bp-profiles-attributes.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BPProfilesAttributesComponent implements AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('profileAttributesForm') public profileAttributesForm:NgForm;
  // Two-way input binding of model this will automatically update input value in parent component
  @Input() public model:IProfileAttribute[];
  // Indicate that wizard is in edit state or read-only
  @Input() public editingMode:boolean;
  // If this input filled-in then component will check for certain attribute code which user has permissions to update
  // values contains of profile attribute 'code'
  @Input() public readOnlyFields:string[];
  // View code of BP profile permissions (security object code)
  @Input() public viewCode:string;
  // Show document upload button
  @Input() public showDocumentButton:boolean;
  // Upload button url
  @Input() public getUploadUrl:DocumentUrlExpression;
  // Download document url
  @Input() public getDocumentUrl:DocumentUrlExpression;
  // Two-way output binding when model change
  @Output() public modelChange:EventEmitter<IProfileAttribute[]> = new EventEmitter<IProfileAttribute[]>();
  public profileAttributes:IProfileAttributeModel[];
  public hasWritePermission:boolean;

  private onValueChangesSubscription:Subscription;
  private onValidationStartSubscription:Subscription;

  constructor(
    private bpProfilesAttributesService:BPProfilesAttributesService,
    private lovService:LovService,
    private authService:AuthService,
    private scrollService:ScrollService,
    private deferredService:GaDeferredService
  ) {
    /**/
  }

  public get showInfoWhenEdit():boolean {
    return this.viewCode === BPProfilesViewCode.TC && this.editingMode;
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.viewCode) {
      this.hasWritePermission = this.authService.viewSpecial(changes.viewCode.currentValue);
    }

    if (changes.model?.isFirstChange() && changes.model?.currentValue) {
      this.processModel(changes.model.currentValue);
    }

    if (changes.editingMode) {
      // when editing mode is true then load list of values
      this.loadListOfValues(changes.editingMode.currentValue);
    }
  }

  public ngAfterViewInit():void {
    // register listener
    this.listen();
  }

  private listen():void {
    this.onValueChangesSubscription = this.profileAttributesForm.form.valueChanges.subscribe(() => {
      if (this.showDocumentButton) {
        // if document type is available then always recalculate document counts for validation purposes
        this.recalculateDocumentCounts();
      }
      // listen on form model changes and then emit updated value to 'model' input bindings
      this.modelChange.emit(this.profileAttributes);
    });
    this.onValidationStartSubscription = this.bpProfilesAttributesService.onValidationStart.subscribe(this.onValidationStart);
  }

  private processModel = (model:IProfileAttribute[]):void => {
    this.profileAttributes = _.sortBy(this.bpProfilesAttributesService.processModel(model), (profileAttribute:IProfileAttributeModel) => this.isFieldEditable(profileAttribute) ? profileAttribute.sequence : -1);
  };

  public getAgreeLabel(profileAttribute:IProfileAttributeModel):string {
    return this.bpProfilesAttributesService.formatAgreeLabel(profileAttribute);
  }

  public compareSelectValues = (comparedBy:string):Function => {
    return (value1:ILov, value2:ILov):boolean => _.isEqual(value1?.[comparedBy], value2?.[comparedBy]);
  };

  public isSelectDisabled(profileAttribute:IProfileAttributeModel):boolean {
    return profileAttribute.attributeValue?.agreeing !== ProfileAttributeAgreeType.NOT_AGREE || profileAttribute.loading;
  }

  public isFieldRequired(profileAttribute:IProfileAttributeModel):boolean {
    return profileAttribute.attributeValue.agreeing === ProfileAttributeAgreeType.NOT_AGREE;
  }

  public isDocumentRequired(profileAttribute:IProfileAttributeModel):boolean {
    return profileAttribute.documentMandatory && profileAttribute.attributeValue?.agreeing === ProfileAttributeAgreeType.AGREE;
  }

  public isDocumentInvalid(profileAttribute:IProfileAttributeModel):boolean {
    return this.isDocumentRequired(profileAttribute) && !profileAttribute.countDocuments;
  }

  public isFieldEditable(profileAttribute:IProfileAttributeModel):boolean {
    return _.find(this.readOnlyFields, (code:string) => profileAttribute.code === code) ? this.hasWritePermission : true;
  }

  public isCommentFieldDisabled(profileAttribute:IProfileAttributeModel):boolean {
    return util.isNullOrUndefinedOrEmpty(profileAttribute.attributeValue?.agreeing);
  }

  public getControlName(name:string, index:number, suffix?:number):string {
    let fieldName:string = `${name}-${index}`;
    if (!_.isUndefined(suffix)) {
      fieldName += `-${suffix}`;
    }
    return fieldName;
  }

  public isTypeBoolean(profileAttribute:IProfileAttributeModel):boolean {
    return profileAttribute.valueType === ProfileAttributeValueType.BOOLEAN;
  }

  public isTypeReal(profileAttribute:IProfileAttributeModel):boolean {
    return profileAttribute.valueType === ProfileAttributeValueType.REAL;
  }

  public isTypeList(profileAttribute:IProfileAttributeModel):boolean {
    return profileAttribute.valueType === ProfileAttributeValueType.LIST;
  }

  public hasValidationError(profileAttribute:IProfileAttributeModel):boolean {
    return profileAttribute.attributeValue?.agreeing === ProfileAttributeAgreeType.NOT_AGREE && (
      util.isNullOrUndefinedOrEmpty(profileAttribute.attributeValue?.realValue) &&
      util.isNullOrUndefinedOrEmpty(profileAttribute.attributeValue?.codeValue) &&
      util.isNullOrUndefinedOrEmpty(profileAttribute.attributeValue?.booleanValue)
    );
  }

  private loadListOfValues(editingMode:boolean):void {
    if (editingMode) {
      _.forEach(this.profileAttributes, (profileAttribute:IProfileAttributeModel) => {
        if (profileAttribute.valueType === ProfileAttributeValueType.LIST ||
          (this.getUploadUrl && profileAttribute.valueType === ProfileAttributeValueType.BOOLEAN && util.notNullOrUndefinedOrEmpty(profileAttribute.groupCode))) {
          // load list of values when value type is list or document type is available within the object
          profileAttribute.loading = true;
          this.lovService.list(profileAttribute.codeSet?.name || LOV_DOCTYPE)
            .then((values:ILov[]) => {
              profileAttribute.listOfValues = values;
            })
            .finally(() => {
              profileAttribute.loading = false;
            });
        }
      });
    }
  }

  public addDocument(profileAttribute:IProfileAttributeModel):void {
    if (!profileAttribute.attributeValue?.documents?.length) {
      profileAttribute.attributeValue.documents = [];
    }
    // add empty document
    profileAttribute.attributeValue.documents.push(<any>{
      documentType: profileAttribute.documentType,
      uploadDeferred: this.deferredService.defer()
    });
  }

  public deleteDocument(document:IProfileAttributeDocument):void {
    document.isDeleted = true;
    this.recalculateDocumentCounts();
  }

  public onDocumentChange(document:IProfileAttributeDocument):void {
    document.isUpdated = true;
    document.formData = util.deepClone({
      doc_desc: document.description || document.file?.name,
      doc_type_code: document.documentType?.code
    });
  }

  public onFileAdd(file:File, document:IProfileAttributeDocument):void {
    document.description = document.description || file.name;
    document.file = file;
    document.isAdded = true;
    this.onDocumentChange(document);
  }

  public async startUpload():Promise<void> {
    for (const profileAttribute of this.profileAttributes) {
      for (const document of profileAttribute.attributeValue?.documents || []) {
        if (document.isAdded && !document.isDeleted && !document.id) {
          // notify file-button component to start upload
          document.uploading = true;
          document.submitting = true;
          // wait until upload is finished before proceed to next upload if any
          // to prevent api resource lock if uploading many files at the same time
          await document.uploadDeferred.promise;
        }
      }
    }
  }

  public onUploadDone(document:IProfileAttributeDocument):void {
    // indicate file-upload component upload has ended
    document.submitting = false;
    document.uploading = false;
    document.isAdded = false;
    document.uploadDeferred.resolve();
  }

  private recalculateDocumentCounts():void {
    _.forEach(this.profileAttributes, (profileAttribute:IProfileAttributeModel) => {
      if (profileAttribute.documentMandatory) {
        const counter:Dictionary<number> = _.countBy(profileAttribute.attributeValue?.documents, (document:IProfileAttributeDocument) => {
          if ((document.id && !document.isDeleted) || (!document.id && document.isAdded && !document.isDeleted)) {
            return 'docs';
          }
        });
        profileAttribute.countDocuments = counter.docs || 0;
      }
    });
  }

  private onValidationStart = ():void => {
    if (this.profileAttributesForm.form.invalid) {
      // scroll to a field which has error
      // add timeout for class to be rendered in DOM
      setTimeout(() => {
        this.scrollService.scrollToElement('.has-error');
      });
      // emit validation error
      this.bpProfilesAttributesService.emitValidationError();
    } else {
      // emit validation success
      this.bpProfilesAttributesService.emitValidationSuccess();
    }
  };

  public ngOnDestroy():void {
    this.onValueChangesSubscription?.unsubscribe();
    this.onValidationStartSubscription?.unsubscribe();
  }
}